<template>
	<Sidebar v-model:visible="visible" :header="header" position="right" @hide="onHide">
		<div v-if="deviceForm" class="pb-6">
			<DevicePropertiesForm :form="deviceForm" @on-save="saveDevice" :disabled="!$auth.hasPermission('update:devices|create:devices')"/>
		</div>
	</Sidebar>
</template>

<script>
import { useDevicesStore } from "@/stores/devices.js";
import { mapStores } from "pinia";
import DevicePropertiesForm from "@/Forms/Device/DevicePropertiesForm.vue";

export default {
	name: "DeviceSlideOver",
	components: {DevicePropertiesForm},
	data() {
		return {
			visible: false,
			device: undefined,
			deviceForm: undefined,
		}
	},
	computed: {
		...mapStores(useDevicesStore),
		header(){
      return this.device?.id
          ? this.$t('slide_overs.device_slide_over.edit_device')
          : this.$t('slide_overs.device_slide_over.create_device');
		},
	},
	methods: {
		async createDevice() {
			this.visible = true;

			this.deviceForm = await this.devicesStore.createDevice();
		},
		async editDevice(device) {
			if (!device)
				return;

			this.device = device;
			this.visible = true;

			this.deviceForm = await this.devicesStore.editDevice(device.id);
		},
		async saveDevice() {
			try {
				await this.deviceForm.submit();
        this.$toast.add({
          severity: 'success',
          summary: this.$t('common.complete'),
          detail: this.$t('pages.admin.devices.devices.device.properties.device_properties_view.device_saved'),
          life: 3000
        });
				this.$emit('saved');
				this.visible = false;
			} catch (error) {
				//
			}
		},
		onHide() {
			this.device = undefined;
			this.deviceForm = undefined;
		},
	},
}
</script>
